// Targeting: nearest enemy by slot (frontmost reachable). Ties broken randomly.

import type { Unit } from "../units/Unit";
import type { CombatContext } from "./CombatContext";
import type { RNG } from "../game/RNG";

export function chooseTarget(unit: Unit, ctx: CombatContext, rng: RNG): Unit | null {
  const enemyTeam: "player" | "enemy" = unit.team === "player" ? "enemy" : "player";
  const candidates = ctx.livingUnitsOf(enemyTeam).filter(
    (u) => u.stasisTurnsRemaining <= 0 && ctx.canReach(unit, u),
  );
  if (candidates.length === 0) return null;

  // Prefer the enemy closest to their own frontline (smallest slot index).
  let minSlot = Infinity;
  for (const c of candidates) minSlot = Math.min(minSlot, c.pos.q);
  const frontmost = candidates.filter((c) => c.pos.q === minSlot);
  return rng.pick(frontmost);
}
